/* eslint-disable import/prefer-default-export */

/**
 * Read the logged-in user record that login writes to localStorage under 'user'.
 *
 * Every caller used to do this inline as `JSON.parse(localStorage.getItem('user')).<field>`,
 * which throws two different ways: JSON.parse(null) returns null when the key is absent, so
 * the property read blows up, and a malformed value throws inside parse itself. Either one
 * aborts the lifecycle hook it happens to sit in, taking the rest of that hook with it.
 *
 * The key can legitimately be missing on a session that is otherwise valid: the auth token is
 * stored in localforage (IndexedDB) by auth/vuex/plugin.js, while this record is in
 * localStorage. Clearing one and not the other leaves a working token with no profile, and
 * loadUser() only re-reads localStorage — it never re-fetches — so nothing restores it.
 *
 * Callers get null and must handle it. NavBar treats a falsy user as an unusable session and
 * redirects to login, which is how the app recovers from exactly that state.
 *
 * @returns {Object|null} the parsed record, or null if absent/unusable
 */
export const readStoredUser = () => {
  try {
    const raw = localStorage.getItem('user')
    if (!raw) { return null }
    const parsed = JSON.parse(raw)
    // The literal string 'null', and any scalar, parse without error but are not a record.
    return parsed && typeof parsed === 'object' ? parsed : null
  } catch (e) {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/utils/storedUser.js